import * as z from 'zod';

export const fcm_tokens_collection_name = 'fcm_tokens';

export const FcmTokenSchema = z.object({
  uid: z.string(),
  token: z.string(),
  created: z.date(),
  updated: z.date(),
});

export type FcmToken = z.infer<typeof FcmTokenSchema>;
